/* Your Wants & Needs — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = (window.YWN && window.YWN.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, showLink) {
    var el = $('#toast');
    if (!el) return;
    $('.toast__msg', el).textContent = msg;
    $('.toast__link', el).hidden = !showLink;
    el.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-open'); }, 4000);
  }

  /* ---------- Wants / Needs mode ---------- */
  var MODE_KEY = 'ywn-mode';
  function applyMode(mode, persist) {
    document.body.setAttribute('data-mode', mode);
    $$('.toggle__opt').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.mode === mode));
    });
    if (persist) {
      try { localStorage.setItem(MODE_KEY, mode); } catch (e) {}
    }
  }

  function initMode() {
    var saved = 'all';
    try { saved = localStorage.getItem(MODE_KEY) || 'all'; } catch (e) {}
    applyMode(saved, false);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.toggle__opt');
      if (!btn) return;
      e.preventDefault();
      var next = btn.dataset.mode;
      if (document.body.getAttribute('data-mode') === next) next = 'all';
      applyMode(next, true);
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var form = $('[data-search]');
    if (!form) return;
    var field = $('.search__field', form);
    var panel = $('.suggest', form);
    if (!field || !panel) return;

    var timer, controller;

    function close() { panel.hidden = true; panel.innerHTML = ''; }

    field.addEventListener('input', function () {
      var q = field.value.trim();
      clearTimeout(timer);
      if (q.length < 2) return close();

      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = window.YWN.routes.predictive +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search';

        fetch(url.replace('&section_id=predictive-search', '') + '&resources[options][unavailable_products]=last', { signal: controller.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) { render(data, q); })
          .catch(function () {});
      }, 220);
    });

    function render(data, q) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var html = '';

      if (collections.length) {
        html += '<div class="suggest__head eyebrow">Departments</div>';
        collections.slice(0, 3).forEach(function (c) {
          html += '<a class="suggest__item" href="' + c.url + '"><div class="suggest__t">' + esc(c.title) + '</div></a>';
        });
      }
      if (products.length) {
        html += '<div class="suggest__head eyebrow">Products</div>';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          html += '<a class="suggest__item" href="' + p.url + '">' +
            (img ? '<img src="' + img + '&width=80" alt="" loading="lazy">' : '<img alt="">') +
            '<div><div class="suggest__t">' + esc(p.title) + '</div>' +
            '<div class="suggest__p">' + money(p.price) + '</div></div></a>';
        });
      }
      if (!html) {
        html = '<div class="suggest__head">No matches for &ldquo;' + esc(q) + '&rdquo;. Try a broader word.</div>';
      } else {
        html += '<a class="suggest__item" href="/search?q=' + encodeURIComponent(q) +
                '"><div class="suggest__t"><b>See all results for &ldquo;' + esc(q) + '&rdquo;</b></div></a>';
      }
      panel.innerHTML = html;
      panel.hidden = false;
    }

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
    field.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var burger = $('.burger');
    var nav = $('.header__nav');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var input = $('input', btn.parentElement);
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      input.value = Math.max(min, btn.dataset.qty === 'up' ? val + 1 : val - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    $$('[data-variants]').forEach(function (root) {
      var data;
      try { data = JSON.parse($('[data-variant-json]', root).textContent); } catch (e) { return; }

      var idInput   = $('[data-variant-id]', root);
      var priceWrap = $('[data-variant-price]', root);
      var stockEl   = $('[data-variant-stock]', root);
      var submit    = $('[data-add]', root);
      var skuEl     = $('[data-variant-sku]', root);

      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-opt]')) return;

        var chosen = $$('[data-opt]', root)
          .filter(function (i) { return i.checked || i.tagName === 'SELECT'; })
          .map(function (i) { return i.value; });

        var variant = data.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });

        if (!variant) {
          submit.disabled = true;
          submit.textContent = 'Unavailable';
          return;
        }

        idInput.value = variant.id;
        if (priceWrap) priceWrap.innerHTML = priceMarkup(variant);
        if (skuEl) skuEl.textContent = variant.sku || '';

        if (stockEl) {
          if (!variant.available) {
            stockEl.className = 'buybox__stock stock--out';
            stockEl.textContent = 'Sold out';
          } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
            stockEl.className = 'buybox__stock stock--low';
            stockEl.textContent = 'Only ' + variant.inventory_quantity + ' left';
          } else {
            stockEl.className = 'buybox__stock stock--in';
            stockEl.textContent = 'In stock';
          }
        }

        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to cart' : 'Sold out';

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      });

      function priceMarkup(v) {
        var out = '<span class="price__now">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
          out += '<span class="price__was">' + money(v.compare_at_price) + '</span>' +
                 '<span class="price__save">Save ' + pct + '%</span>';
        }
        return out;
      }
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.gallery__thumb');
      if (!thumb) return;
      var gallery = thumb.closest('.gallery');
      var main = $('.gallery__main img', gallery);
      if (!main) return;
      main.src = thumb.dataset.full;
      main.srcset = '';
      main.alt = thumb.dataset.alt || '';
      $$('.gallery__thumb', gallery).forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
    });
  }

  /* ---------- Add to cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-form]');
      if (!form) return;
      e.preventDefault();

      var btn = $('[data-add]', form);
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }

      fetch(window.YWN.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(serialize(form))
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || window.YWN.strings.error);
          return fetch(window.YWN.routes.cart + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCount(cart.item_count);
          toast(window.YWN.strings.added, true);
        })
        .catch(function (err) { toast(err.message || window.YWN.strings.error, false); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  }

  function serialize(form) {
    var fd = new FormData(form);
    var out = { quantity: 1, properties: {} };
    fd.forEach(function (value, key) {
      if (key === 'id') out.id = value;
      else if (key === 'quantity') out.quantity = parseInt(value, 10) || 1;
      else if (key.indexOf('properties[') === 0) {
        out.properties[key.slice(11, -1)] = value;
      }
    });
    if (!Object.keys(out.properties).length) delete out.properties;
    return out;
  }

  /* ---------- Cart line updates ---------- */
  function initCartPage() {
    var cart = $('[data-cart-page]');
    if (!cart) return;

    function change(line, quantity) {
      cart.style.opacity = '.5';
      fetch(window.YWN.routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { cart.style.opacity = '1'; toast(window.YWN.strings.error, false); });
    }

    cart.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      change(parseInt(e.target.dataset.line, 10), parseInt(e.target.value, 10));
    });

    cart.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (!rm) return;
      e.preventDefault();
      change(parseInt(rm.dataset.line, 10), 0);
    });
  }

  /* ---------- Facet auto-submit ---------- */
  function initFacets() {
    var form = $('[data-facets]');
    if (!form) return;
    form.addEventListener('change', function () { form.submit(); });
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initMode();
    initSearch();
    initNav();
    initQty();
    initVariants();
    initGallery();
    initAddToCart();
    initCartPage();
    initFacets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
